import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuickPickupChosenDuotone24 = function SvgQuickPickupChosenDuotone24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v.5h.51l-.01-.51zm-12.654 0h-.5v.5h.5zm0-11.76v-.5h-.5v.5zm12.41 0 .5-.01-.01-.49h-.49zm-9.084 1.68v.5h1v-.5zm4.708 0v.5h1v-.5zm-11.047-.553a.5.5 0 0 0 0-1zm-6.333-1a.5.5 0 1 0 0 1zm6.333 2.68a.5.5 0 0 0 0-1zm-3.096-1a.5.5 0 1 0 0 1zm3.096 2.96a.5.5 0 1 0 0-1zm-1.33-1a.5.5 0 0 0 0 1zM23 22.5H10.346v1H23zm-12.154.5V11.24h-1V23zm-.5-11.26h12.41v-1h-12.41zm11.91-.49.244 11.76 1-.02-.243-11.76zm-7.584 1.67v-1.96h-1v1.96zm0-1.96c0-.724.74-1.46 1.854-1.46v-1c-1.486 0-2.854 1.02-2.854 2.46zm1.854-1.46c1.114 0 1.854.736 1.854 1.46h1c0-1.44-1.368-2.46-2.854-2.46zm1.854 1.46v1.96h1v-1.96zm-11.047.407H1v1h6.333zm0 1.68H4.237v1h3.096zm0 1.96h-1.33v1h1.33z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-color",
    clipRule: "evenodd",
    d: "M8 1a6.006 6.006 0 0 0-6 6 6.007 6.007 0 0 0 6 6 6.008 6.008 0 0 0 6-6 6.007 6.007 0 0 0-6-6z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.679 7.143 7.25 9.286l4.286-4.715",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
};

var QuickPickupChosenDuotone24Svg = SvgQuickPickupChosenDuotone24;

export { QuickPickupChosenDuotone24Svg as default };
//# sourceMappingURL=QuickPickupChosenDuotone24.svg.js.map
